import React from 'react';
import PropTypes from 'prop-types';
import { connect, useSelector } from 'react-redux';
import { Spin } from 'antd';

import selectors from '../../../store/selectors';
import '../../../styles/index.scss';
import { Footer, Header } from '..';

import DeathPrayersConfirmation from './components/DeathPrayersConfirmation';
import DeathPrayersForm from './components/DeathPrayersForm';

const enhance = connect(state => ({
  deathPrayers: selectors.getDeathPrayers(state),
  isDonateConfirmation: selectors.isDonateConfirmation(state),
}));

const DeathPrayersLayout = ({ deathPrayers, isDonateConfirmation, isLoading }) => {
  const deathPrayersFeatureFlag = useSelector(selectors.getDeathPrayersFeatureFlag);
  return (
    <>
      <div className="app h-100 d-flex flex-column">
        <Header description="Wypominki online" />

        <main>
          <div className="wrapper info mt-5">
            <div className="parish-info container-lg px-lg-0 text-justify text-lg-left">
              <h1 className="el-h4 mb-4">Wypominki</h1>
            </div>
          </div>
          <div className="donation-form-wrapper mt-lg-0 px-lg-5">
            <div className="container-lg px-lg-0">
              {!isLoading && (
                <>
                  {!deathPrayersFeatureFlag && (
                    <p>Nie przyjmujemy obecnie wypominek poprzez formularz online.</p>
                  )}
                  {deathPrayersFeatureFlag && (
                    <>
                      {!isDonateConfirmation && (
                        <div dangerouslySetInnerHTML={{ __html: deathPrayers.formIntroduction }} />
                      )}
                      {isDonateConfirmation ? <DeathPrayersConfirmation /> : <DeathPrayersForm />}
                    </>
                  )}
                </>
              )}
              {isLoading && <Spin />}
            </div>
          </div>
        </main>
        <Footer isWhite mtAuto />
      </div>
    </>
  );
};

DeathPrayersLayout.propTypes = {
  isDonateConfirmation: PropTypes.bool,
  deathPrayers: PropTypes.shape({
    formIntroduction: PropTypes.string,
    formDonatorLabel: PropTypes.string,
  }),
  isLoading: PropTypes.bool,
};

export default enhance(DeathPrayersLayout);
